import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const LaborContractInformationTable = observer(() => {
  const {
    employeeManagement: { employeeDetail },
  } = useStores();

  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell align="center" colSpan={6}>
            Thông Tin Hợp Đồng LĐ
          </TableCell>
          <TableCell align="center" colSpan={5}>
            Thông Tin Bảo Hiểm
          </TableCell>
          <TableCell align="center" rowSpan={2}>
            Ngày Tham Gia CĐ
          </TableCell>
          <TableCell align="center" rowSpan={2}>
            MST Cá Nhân
          </TableCell>
          <TableCell align="center" rowSpan={2}>
            Ghi Chú
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell align="center">Loại HĐ</TableCell>
          <TableCell align="center">Kỳ Hạn</TableCell>
          <TableCell align="center">Số HĐ</TableCell>
          <TableCell align="center">Ngày Ký</TableCell>
          <TableCell align="center">Ngày ĐH</TableCell>
          <TableCell align="center">Ghi Chú</TableCell>
          <TableCell align="center">Số BHXH</TableCell>
          <TableCell align="center">Số BHYT</TableCell>
          <TableCell align="center">Nơi KCB</TableCell>
          <TableCell align="center">Thời Điểm Đóng BH</TableCell>
          <TableCell align="center">Ghi Chú</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractTypeModel?.value || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractTermTypeModel?.value ||
              ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractSigningDate &&
              dateTimeDisplay(
                employeeDetail?.contractInsurance?.contractSigningDate
              )}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractExpirationDate &&
              dateTimeDisplay(
                employeeDetail?.contractInsurance?.contractExpirationDate
              )}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.contractNote || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.socialInsuranceNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.healthInsuranceNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.kcbPlace || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.insurancePaymentDate &&
              dateTimeDisplay(
                employeeDetail?.contractInsurance?.insurancePaymentDate
              )}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.insuranceNote || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.cdJoiningDate &&
              dateTimeDisplay(employeeDetail?.contractInsurance?.cdJoiningDate)}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.personalTaxID || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.contractInsurance?.note || ""}
          </TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
